export default __webpack_public_path__ + "images/View_of_Upper_Limb_dark.184f0e1dedeb6498fde246ac37a3d2a7.png";